import { Injectable } from '@angular/core';
import { CookieAppService } from '@shared/common/services/cookie-app/cookie-app.service';
import { AUTH_COOKIE } from '../constants/auth.constant';
import { AccountApi, AccountApiModule } from '@limehome/account-api-client';

@Injectable({ providedIn: 'root' })
export class AuthService {
  publicModule: AccountApiModule;
  constructor(
    protected cookieAppService: CookieAppService,
    protected accountApi: AccountApi
  ) {
    this.setPublicModule();
  }

  /**
   * Returns 'auth' token from cookie storage
   * TODO: Remove the token parsing(try-catch block) after all mobile users upgraded to newest release
   * @see {@link https://limehome.atlassian.net/browse/GS-1882}
   * @returns {string}
   */
  get authToken(): string | null {
    const authToken = this.cookieAppService.getCookie(AUTH_COOKIE);

    if (!authToken) return null;

    try {
      const parsedToken = JSON.parse(authToken);
      const hasTokenField = parsedToken && typeof parsedToken === 'object' && 'token' in parsedToken;
      if (hasTokenField) {
        return parsedToken.token;
      }
    } catch (error) {}

    return authToken;
  }

  get isAuthenticated(): boolean {
    return !!this.authToken;
  }

  /**
   * Sets publicModule for accountApiClient
   */
  setPublicModule() {
    try {
      this.publicModule = this.accountApi.module('public');

      if (!this.publicModule) {
        throw new Error('Failed to initialize API module or resource.');
      }
    } catch (error) {
      console.error('Error initializing AuthService:', error);
    }
  }

  /**
   * Sets token in Cookie Storage
   * @param token
   * @param expires
   */
  setToken(token: string, expires = 365) {
    this.cookieAppService.setCookie(AUTH_COOKIE, token, expires);
  }

  /**
   * Removes token from Cookie storage
   */
  removeToken() {
    this.cookieAppService.removeCookie(AUTH_COOKIE);
  }

  /**
   * Returns an observable when refresh token is attempted
   * @returns {Observable<AccountApiTokenResponse>}
   */
  refreshToken() {
    return this.accountApi.refreshToken();
  }

  /**
   * Used to Sign-In a user account
   * @param username
   * @param password
   * @returns {Observable<AccountApiTokenResponse>}
   */
  signIn(username: string, password: string) {
    return this.accountApi.getPublicToken(username, password);
  }

  /**
   * User to sign out a user account
   * @returns {Observable<AccountApiSuccessResponse>}
   */
  signOut() {
    return this.accountApi.logout();
  }
}
